import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueSlimScroll from 'vue-slimscroll'
import Multiselect from 'vue-multiselect'
import CodiumVue from '@codium/codium-vue'
import { configure as configureValidation } from 'vee-validate'
import * as GmapVue from 'gmap-vue'
import localforage from 'localforage'

/**
 * Import other dependencies.
 */
import 'mixins'
import 'filters'
import 'utils/font-awesome'
import 'utils/validation'
import 'utils/components'
import 'jquery'
import 'bootstrap-sass'
import 'utils/notify'
import 'utils/echo'

/**
 * Import theme SCSS.
 */
import 'assets/scss/theme.scss'

localforage.config({
  driver: localforage.LOCALSTORAGE,
  name: 'LHD',
  version: 1.0,
  storeName: 'lhd_nsw'
})

Vue.use(VueSlimScroll)
Vue.component('multiselect', Multiselect)
Vue.use(CodiumVue)

configureValidation({
  classes: {
    invalid: 'has-error',
    valid: ''
  }
})

Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GMAP_API_KEY,
    libraries: 'directions'
  },
  installComponents: false
})

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
